module.exports = __webpack_public_path__ + "static/media/prof-titanji-aca-week.b07e164d.jpg";